function RichTextTrimmerOverlay({ isVisible }: RichTextTrimmerOverlayProps) {
  return isVisible ? (
    <div className="absolute bottom-0 left-0 w-full h-[50%] bg-gradient-to-t from-white" />
  ) : (
    <></>
  )
}

interface RichTextTrimmerOverlayProps {
  isVisible: boolean
}

export default RichTextTrimmerOverlay
